export const SECURITY_WARNING = "Security Warning: <script> tags are not allowed in templates."

export function containsScriptTags(html: string): boolean {
	const scriptTagRegex = /<script[\s\S]*?>[\s\S]*?<\/script>|<script[\s\S]*?\/>/gi
	return scriptTagRegex.test(html)
}

export function isValidJson(text: string): boolean {
	try {
		JSON.parse(text)
		return true
	} catch {
		return false
	}
}
